import { Trash01Icon } from '@/components/icons/Trash01Icon';
import {
  ConfirmationModal,
  ConfirmationModalProps,
} from '@/components/modals/ConfirmationModal/ConfirmationModal';
import {
  MenuItem,
  MenuItemProps,
} from '@/components/poppers/MenuPopper/MenuItem';
import { useModalState } from '@/hooks/useModalState';

export interface DeleteMenuItemWithConfirmationModalProps {
  label: React.ReactNode;
  menuItemProps?: Partial<MenuItemProps>;
  modalProps?: Partial<ConfirmationModalProps>;
  onConfirmDelete: () => void;
}

export function DeleteMenuItemWithConfirmationModal({
  onConfirmDelete,
  label,
  menuItemProps = {},
  modalProps = {},
}: DeleteMenuItemWithConfirmationModalProps) {
  const [{ isModalOpen }, { setModalIsOpen }] = useModalState();

  const { loading } = menuItemProps;

  return (
    <>
      <ConfirmationModal
        isOpen={isModalOpen}
        heading="Are you sure you want to delete this?"
        cancelText="Cancel"
        confirmText="Delete"
        confirmButtonProps={{
          variant: 'destructive-primary',
          disabled: loading,
        }}
        {...modalProps}
        onClose={(result) => {
          if (result === 'confirm') {
            onConfirmDelete();
          }
          setModalIsOpen(false);
        }}
      />
      <MenuItem
        variant="destructive"
        icon={<Trash01Icon size={16} />}
        label={label}
        onClick={(event) => {
          event.stopPropagation();
          setModalIsOpen(true);
        }}
        {...menuItemProps}
      />
    </>
  );
}
